import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes";
import { Dimmer } from "../../spinner";
import axios from "axios";
import useTableFijo from "../../useTableFijo";
import { formatMoneda, validaMonto } from "../../../util/varios";
import { AgregarDescuento } from "./modalAgregarDescuento";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../../ui/buttons/Button";
import { Input, Radio } from "../../../ui/inputs/Input";
export const ConfiguracionModuloVehiculo = (props) => {
  let heightTabla = 180;
  let ope = 2;
  const headCells = [
    {
      id: "1",
      label: "Periodo Inicio",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      disableSorting: true,
    },
    {
      id: "2",
      label: "Periodo Fin",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      disableSorting: true,
    },
    {
      id: "3",
      label: "% Descuento",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "white",
      disableSorting: true,
    },
  ];

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../../src/modulos/datos");
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const radioAnual = useRef();
  const radioTrimestral = useRef();
  const radioMensual = useRef();
  const radioBs = useRef();
  const radioUnidad = useRef();
  const radioPetros = useRef();
  const radioSueldoMin = useRef();
  const radioUtMunicipal = useRef();
  const radioOtroFactor = useRef();
  const radioIntMoraFijo = useRef();
  const txtPorceInt = useRef();
  const radioIntMoraTasa = useRef();
  const txtPorceRecargo = useRef();
  const radioSi = useRef();
  const radioNo = useRef();
  const [select, setSelect] = useState("2");
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [itemSelect, setItemSelect] = useState(-1);
  const [mostrar, setMostrar] = useState(false);
  const [activate, setActivate] = useState(false);
  const [declawebs, setDeclawebs] = useState(false);
  const [filterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [fechaSistema] = useState(localStorage.getItem("fechasistema"));
  const [operacion, setOperacion] = useState(0);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({
    periodopag: 0,
    periododeclaracio: 0,
    factorcalcul: 0,
    valorporcentua: 0,
    tipointere: 0,
    porcentajeintere: "0,00",
    porcentajerecarg: "0,00",
    mesesdecladef: "0,00",
    ptoimpr: 0,
    diavendeud: 0,
    factormult: 0,
    valormult: "0,00",
    diavendeudare: 0,
    declaracionwe: false,
    notifrit: false,
    diavendeuda1: 0,
    diavendeuda2: 0,
    mesdesdequincen: 0,
    porcenimpuest: "0,00",
  });
  const { TblContainer, TblHead } = useTableFijo(
    records,
    headCells,
    filterFn,
    heightTabla
  );
  const seleccionnarModulo = () => {
    let nomtab = "configvehiculo";
    let endpoint =
      op.conexion + `/api/comun/seleccionarmodulo?&nomtab=${nomtab}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setValues(response.data);
          if (response.data !== "") {
            if (response.data.tipointere === 1) {
              setSelect("1");
            } else {
              setSelect("2");
            }
          }
        }
      })
      .catch((error) => {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarDescuento = () => {
    let campos = "*";
    let nomtab = "tabladescuentos";
    let nomid = "tipoimpuesto";
    let id = 5;
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarDeclaWeb = () => {
    let campos = "*";
    let nomtab = "configvehiculo";
    let orden = "1";
    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setDeclawebs(response.data[0].declaracionweb);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
      });
  };
  const crearMovimientoWeb = (operacion, nomtab, idtab) => {
    let endpoint = `${op.conexion}/api/comun/crearmovimientoweb/${operacion}`;
    let body;
    setActivate(true);
    body = {
      idmovi: null,
      nomtabla: nomtab,
      idtab: idtab,
      fecmovi: fechaSistema,
      riff: null,
      idcomer: idtab,
      idact: null,
      nanio: null,
      mess: null,
      tipdecla: null,
      numfac: null,
      prefac: null,
      operaper: null,
      actu: false,
      nmes: null,
      tip: null,
      peri: null,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/comun/actualizarmodulo`;
    let body;
    setActivate(true);
    body = {
      tipoconf: 5,
      periodo: radioAnual.current.checked
        ? 1
        : radioTrimestral.current.checked
        ? 2
        : 3,
      factor: radioBs.current.checked
        ? 1
        : radioUnidad.current.checked
        ? 2
        : radioPetros.current.checked
        ? 3
        : radioSueldoMin.current.checked
        ? 4
        : radioUtMunicipal.current.checked
        ? 5
        : 6,
      valor: null,
      decla: null,
      tipint: radioIntMoraFijo.current.checked ? 1 : 2,
      porint:
        select === "2"
          ? 0.0
          : txtPorceInt.current.value
              .trim()
              .replace(/\./g, "")
              .replace(",", "."),
      porrec: txtPorceRecargo.current.value
        .trim()
        .replace(/\./g, "")
        .replace(",", "."),
      meses: null,
      diaven: null,
      diavenreg: null,
      pto: null,
      factor1: null,
      valormul: null,
      declaweb: radioSi.current.checked ? true : false,
      diavenqui1: null,
      diavenqui2: null,
      cmbMes: null,
      descu: records,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (declawebs === true) {
            crearMovimientoWeb(2, "configvehiculo", 0);
          }
          if (ope === 2) {
            setTitulo("Notificacion");
            setMsg("Registro Creado Correctamente.");
            setMostrar(true);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
    setActivate(true);
  };
  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (
      radioAnual.current.checked === false &&
      radioTrimestral.current.checked === false &&
      radioMensual.current.checked === false
    ) {
      setTitulo("Error");
      setMsg("Debe Seleccionar el Periodo de Pago");
      sigue = false;
      radioAnual.current.focus();
      setMostrar(true);
    } else if (
      radioSi.current.checked === false &&
      radioNo.current.checked === false
    ) {
      setTitulo("Error");
      setMsg("Defina si Declara Web");
      sigue = false;
      radioSi.current.focus();
      setMostrar(true);
    } else if (
      radioBs.current.checked === false &&
      radioUnidad.current.checked === false &&
      radioPetros.current.checked === false &&
      radioSueldoMin.current.checked === false &&
      radioUtMunicipal.current.checked === false &&
      radioOtroFactor.current.checked === false
    ) {
      setTitulo("Error");
      setMsg("Seleccione el Factor Calculo del Minimo Tributable");
      sigue = false;
      radioBs.current.focus();
      setMostrar(true);
    } else if (
      radioIntMoraFijo.current.checked === false &&
      radioIntMoraTasa.current.checked === false
    ) {
      setTitulo("Error");
      setMsg("Seleccione el Tipo de Interes por Mora");
      sigue = false;
      radioIntMoraFijo.current.focus();
      setMostrar(true);
    } else if (
      radioIntMoraFijo.current.checked === true &&
      txtPorceInt.current.value === ""
    ) {
      setTitulo("Error");
      setMsg("Introduzca el Interes por Mora Fijo");
      sigue = false;
      txtPorceInt.current.focus();
      setMostrar(true);
    } else if (txtPorceRecargo.current.value === "") {
      setTitulo("Error");
      setMsg("Introduzca el Recargo por Mora");
      sigue = false;
      txtPorceRecargo.current.focus();
      setMostrar(true);
    } else if (sigue === true) {
      Actualizar(ope);
    }
  };
  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
  };
  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", ".")
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which >= 37 && event.which <= 40) {
      event.preventDefault();
    }

    // Devuelve el número formateado
    let e = event.target.value
      .replace(/\D/g, "")
      .replace(/([0-9])([0-9]{2})$/, "$1.$2")
      .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

    event.target.value = formatMoneda(e); // Asigna el valor formateado de nuevo al campo de entrada

    // Manejo del evento 'Enter'
    if (event.which === 13) {
      if (event.target.id === "interes") {
        txtPorceInt.current.focus();
      } else if (event.target.id === "recargo") {
        txtPorceRecargo.current.focus();
      }
    }
  };

  const handleCloseMensa = (e) => {
    e.preventDefault();
    setMostrar(false);
    if (
      msg == "Registro Creado Correctamente." ||
      msg == "Registro Modificado Correctamente." ||
      msg == "Registro Eliminado Correctamente."
    ) {
      props.onHideCancelam();
      seleccionnarModulo();
      seleccionarDeclaWeb();
    }
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelam();
  };

  const handleAgregarDescuento = (oper) => (e) => {
    e.preventDefault();
    setOperacion(oper);
    setMostrar1(true);
  };

  const handleCancelaDescuento = () => {
    setMostrar1(false);
    setItemSelect(-1);
  };

  const handleRemove = (e) => {
    e.preventDefault();
    var i;
    var datos = [];
    for (i = 0; i < records.length; i++) {
      if (i !== itemSelect) {
        datos.push(records[i]);
      }
    }
    setItemSelect(-1);
    setRecords(datos);
  };

  const onChange = (event) => {
    if (event.target.name === "interesmora") {
      if (radioIntMoraFijo.current.checked) {
        setSelect("1");
      } else if (radioIntMoraTasa.current.checked) {
        setSelect("2");
      }
    }
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
  };

  const handleAceptaDescuento = (pini, pfin, porce) => {
    if (operacion === 1) {
      var valporce = porce === "" ? "0.00" : porce.replace(/\./g, "");
      var valorporce = valporce.replace(",", ".");
      setRecords([
        ...records,
        {
          tipoimpuesto: 5,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: valorporce,
        },
      ]);
    } else if (operacion === 2) {
      var i;
      var datos = [];
      for (i = 0; i < records.length; i++) {
        if (i !== itemSelect) {
          datos.push(records[i]);
        }
      }
      setItemSelect(-1);
      setRecords([
        ...datos,
        {
          tipoimpuesto: 5,
          periodoini: pini,
          periodofin: pfin,
          porcentaje: porce,
        },
      ]);
    }
  };

  useEffect(() => {
    seleccionnarModulo();
    seleccionarDeclaWeb();
    seleccionarDescuento();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Configuración Patente de Vehiculos</h3>
        <a
          type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={cancelar}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2  d-flex flex-wrap">
        <fieldset className="col-6 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">Periódo de Pagos</legend>
          <div className="col m-0 p-0">
            <Radio
              label="Anual"
              ref={radioAnual}
              defaultChecked={values.periodopag === 1 ? true : false}
              name="periodopagos"
              id="periodopagos1"
            />
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="Trimestral"
              ref={radioTrimestral}
              defaultChecked={values.periodopag === 2 ? true : false}
              name="periodopagos"
              id="periodopagos2"
            />
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="Mensual"
              ref={radioMensual}
              defaultChecked={values.periodopag === 3 ? true : false}
              name="periodopagos"
              id="periodopagos3"
            />
          </div>
        </fieldset>
        <fieldset className="col-5 m-0 ml-auto p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">
            Declaración en Linea (Internet)
          </legend>
          <div className="col m-0 p-0">
            <Radio
              label="Si"
              ref={radioSi}
              defaultChecked={values.declaracionwe === true ? true : false}
              name="declaracionlinea"
              value="0"
              id="declaracionlinea1"
            />
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="No"
              ref={radioNo}
              defaultChecked={values.declaracionwe === false ? true : false}
              name="declaracionlinea"
              value="1"
              id="declaracionlinea2"
            />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap justify-content-between border-azul rounded">
          <legend className="float-none w-auto m-0">
            Factor para el Cálculo del Minimo Tributable
          </legend>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Bolivares(Bs.)"
              ref={radioBs}
              defaultChecked={values.factorcalcul === 1 ? true : false}
              name="minimotributable"
              id="minimotributable1"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Unidades Tributarias"
              ref={radioUnidad}
              defaultChecked={values.factorcalcul === 2 ? true : false}
              name="minimotributable"
              id="minimotributable2"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Petros"
              ref={radioPetros}
              defaultChecked={values.factorcalcul === 3 ? true : false}
              name="minimotributable"
              id="minimotributable3"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Sueldo Minimo"
              ref={radioSueldoMin}
              defaultChecked={values.factorcalcul === 4 ? true : false}
              name="minimotributable"
              id="minimotributable4"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="UT Municipal"
              ref={radioUtMunicipal}
              defaultChecked={values.factorcalcul === 5 ? true : false}
              name="minimotributable"
              id="minimotributable5"
            />
          </div>
          <div className="col-auto m-0 p-0">
            <Radio
              label="Otros"
              ref={radioOtroFactor}
              defaultChecked={values.factorcalcul === 6 ? true : false}
              name="minimotributable"
              id="minimotributable6"
            />
          </div>
        </fieldset>
        <fieldset className="col-6 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">Intereses por Mora</legend>
          <div className="col m-0 p-0">
            <Radio
              label="Fijo"
              ref={radioIntMoraFijo}
              name="interesmora"
              defaultChecked={values.tipointere === 1 ? true : false}
              value="0"
              id="interesmora1"
              onChange={onChange}
            />
          </div>
          <div className="col m-0 p-0 pr-4">
            {select === "1" && (
              <div className="col-12 m-0 p-0">
                <Input
                  ref={txtPorceInt}
                  id="interes"
                  defaultValue={formatMoneda(
                    values.porcentajeintere.toString().replace(".", ","),
                    ",",
                    ".",
                    2
                  )}
                  className="form-control form-control-sm text-right"
                  onKeyUp={handleInputMontoChange}
                  onBlur={handleInputMontoChange}
                />
              </div>
            )}
          </div>
          <div className="col m-0 p-0">
            <Radio
              label="Según Tasa"
              ref={radioIntMoraTasa}
              name="interesmora"
              defaultChecked={values.tipointere === 2 ? true : false}
              value="1"
              id="interesmora2"
              onChange={onChange}
            />
          </div>
        </fieldset>
        <fieldset className="col-5 m-0 ml-auto p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">Recargo por Mora</legend>
          <Input
            inputClassName="text-right"
            ref={txtPorceRecargo}
            id="recargo"
            defaultValue={formatMoneda(
              values.porcentajerecarg.toString().replace(".", ","),
              ",",
              ".",
              2
            )}
            onKeyUp={handleInputMontoChange}
            onBlur={handleInputMontoChange}
          />
        </fieldset>
        <div className="col-12 m-0 mt-2 p-0 d-flex">
          <div className="col-11 m-0 p-0">
            <TblContainer
              container={{
                height: 120,
                width: "100%",
                overflow: "auto",
                padding: "2px",
              }}
            >
              <TblHead />
              <tbody>
                {records &&
                  records.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        padding: "0",
                        background:
                          itemSelect === index ? "lightgreen" : "white",
                      }}
                      onClick={seleccionarFila(index)}
                    >
                      <td style={{ fontSize: "12px", textAlign: "center" }}>
                        {item.periodoini}
                      </td>
                      <td style={{ fontSize: "12px", textAlign: "center" }}>
                        {item.periodofin}
                      </td>
                      <td style={{ fontSize: "12px", textAlign: "right" }}>
                        {formatMoneda(
                          item.porcentaje.toString().replace(".", ","),
                          ",",
                          ".",
                          2
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
          <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
            <div className="col-auto m-0 p-0">
              <PrimaryButton
                icon="fa-plus m-0"
                onClick={handleAgregarDescuento(1)}
              />
            </div>
            <div className="col-auto m-0 p-0">
              <WarningButton
                icon="fa-edit m-0"
                disabled={itemSelect === -1 ? true : false}
                onClick={handleAgregarDescuento(2)}
              />
            </div>
            <div className="col-auto m-0 p-0">
              <DangerButton
                icon="fa-trash-alt m-0"
                disabled={itemSelect === -1 ? true : false}
                onClick={handleRemove}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton ref={btnAcepta} onClick={onChangeValidar}>
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill"
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <AgregarDescuento
        show={mostrar1}
        tipoconf={operacion}
        descuento={records[itemSelect]}
        onHideAcepta={handleAceptaDescuento}
        onHideCancela={handleCancelaDescuento}
      />
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={handleCloseMensa}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
